import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { intToString } from 'helper';

const iconInitialClassName = 'text-7xl text-gray-400 font-bold';

function InfoCard({
  containerClassName,
  labelClassName,
  totalClassName,
  iconClassName,
  label,
  total,
  icon: Icon,
  image,
  isLoading,
  loader,
}) {
  if (isLoading) return loader;

  return (
    <div
      className={cn(
        'flex justify-between pl-5 pr-3 pt-4 pb-8 rounded shadow-md bg-white border-[0.5px] gap-x-6 xl:gap-x-3 2xl:gap-x-5',
        containerClassName,
      )}
    >
      <div className="whitespace-nowrap">
        <h5
          className={cn(
            'mb-4 font-[550] text-xs tracking-wide text-gray-500 uppercase',
            labelClassName,
          )}
        >
          {label}
        </h5>
        <div
          className={cn(
            'font-semibold text-gray-700 text-3xl tracking-tight',
            totalClassName,
          )}
        >
          {intToString(+total)}
        </div>
      </div>
      <span className="self-center">
        {image ? (
          Icon
        ) : (
          <Icon className={cn(iconInitialClassName, iconClassName)} />
        )}
      </span>
    </div>
  );
}

InfoCard.defaultProps = {
  containerClassName: '',
  labelClassName: '',
  totalClassName: '',
  iconClassName: '',
  image: false,
  isLoading: false,
};

InfoCard.propTypes = {
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  totalClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  total: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)])
    .isRequired,
  image: PropTypes.bool,
  isLoading: PropTypes.bool,
  loader: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.instanceOf(Object),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default InfoCard;
